import {AfterViewInit, Component, Input, TemplateRef, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {TranslocoService} from "@ngneat/transloco";
import {MatDialog} from "@angular/material/dialog";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {combineLatest} from 'rxjs';
import {map} from 'rxjs/operators';
import {AppService, LocalStoreService, StoreSelectorsService, UserService} from "../../../services";
import {ICartCreate, ICartProduct, IUser} from "../../../interfaces";
import {timeout} from "../../../decorators/timeout";

import * as _ from "lodash";
import {Compbaser} from "../../../components/compbaser";
import {MS_15} from "../../../common";

@Component({
    selector: 'app-products',
    styleUrls: [`./products.component.scss`],
    templateUrl: './products.component.html'
})

export class ProductsComponent extends Compbaser implements AfterViewInit {
    cartProducts: Array<ICartProduct>;
    navigationEnd: NavigationEnd;
    cartCreate: ICartCreate;
    addedProduct: string = null;
    user: IUser;
    globalFilter = '';
    selectedThumb;
    productImages;
    currentRoute = '';
    stringJSPipeArgs = {toCurrency: ['us']};
    theme = '1';
    displayedColumns: string[] = ['item', 'name', 'description', 'price', 'add'];
    dataSource: MatTableDataSource<any>;

    @Input() pageSizeOptions: Array<any> = [10, 30, 50];
    @Input() pageSize = 10;
    @ViewChild("thumbDialogModal", {read: TemplateRef}) thumbDialogModal: TemplateRef<any>;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    constructor(private translocoService: TranslocoService,
                private localStoreService: LocalStoreService,
                private userService: UserService, 
                protected override dialog: MatDialog,
                private router: Router,
                private route: ActivatedRoute,
                private storeSelector: StoreSelectorsService,
                private appService: AppService) {
        super();
        // this.appService.initOnSale();
        this.theme = this.localStoreService.getStorageValConfig('theme');
        this.cod(
            this.storeSelector.getAppSettings().subscribe((appStatic) => this.productImages = appStatic.productImages)
        );
        this.cod(
            this.storeSelector.getUser().subscribe((user) => {
                // this.enterpriseMode = i_user.enterprise;
                // this.dashboard = i_user.dashboard;
                this.user = user;
            })
        );
        this.cod(
            this.router.events.subscribe((e) => {
                if (e instanceof NavigationEnd) {
                    this.navigationEnd = e;
                }
            })
        );
        this.cod(
            combineLatest([this.route.queryParams, this.storeSelector.getCartProducts()]).pipe(
                map(([params, products]) => ({params, products}))
            ).subscribe((v) => {
                if (v && v.products) {
                    this.cartProducts = v.products.filter((p) => {
                        // console.log(p.product_id + ' ' + p.name);
                        // 1-27-2024 took ADZ out
                        return p.product_id != MS_15 && p.name !== 'MS-200U' && p.name !== 'MS-200WV2';
                    });
                    if (v.params && v.params['s']) {
                        setTimeout(() => {
                            const itemToScrollTo = document.getElementById(v.params['s']);
                            // null check to ensure that the element actually exists
                            if (itemToScrollTo) {
                                itemToScrollTo.scrollIntoView(true);
                            }
                        }, 100);
                    }
                    this.applyTableCustomization();
                }
            })
        );
    }

    ngAfterViewInit() {
        this.currentRoute = this.router.url;
    }

    onAddCartNav(product: ICartProduct) {
        // const routeTo = this.isProductInUrl() ? `../../list/${product.product_id}:${_.uniqueId()}` : `../list/${product.product_id}:${_.uniqueId()}`;
        if (this.currentRoute.indexOf('shopping-cart') > -1) {
            this.router.navigate([`../list/${product.product_id}:${_.uniqueId()}`], {relativeTo: this.route});
        } else {
            this.router.navigate([`shopping/list/${product.product_id}:${_.uniqueId()}`]);
        }
    }

    navigateTo(link) {
        switch (link) {
            case 'checkout': {
                this.router.navigate(['../checkout'], {relativeTo: this.route});
                break;
            }
            case 'cart': {
                this.router.navigate(['../list'], {relativeTo: this.route});
                break;
            }
        }
    }

    @timeout(10)
    applyTableCustomization() {
        this.dataSource = new MatTableDataSource(this.cartProducts);
        this.dataSource.paginator = this.paginator;

        this.dataSource.filterPredicate = (data: any, filter) => {
            const dataStr = JSON.stringify(data).toLowerCase();
            return dataStr.indexOf(filter) !== -1;
        };

        this.dataSource.sort = this.sort;
        this.dataSource.sortingDataAccessor = (item: ICartProduct, property) => {
            switch (property) {
                case 'price':
                    return parseFloat(item.price);
                default: {
                    return item[property];
                }
            }
        };
    }

    applyFilter(filterValue: string) {
        if (this.dataSource) this.dataSource.filter = filterValue;
    }
}
